export const ADD_PWD = 'ipfabric/components/DeviceCredentials/ADD_PWD';
export const LOAD_PWDLIST =
  'ipfabric/components/DeviceCredentials/LOAD_PWDLIST';
export const LOAD_ENABLE_PWD =
  'ipfabric/components/DeviceCredentials/LOAD_ENABLE_PWD';
export const UPDATE_PWD = 'ipfabric/components/DeviceCredentials/UPDATE_PWD';
export const DELETE_PWD = 'ipfabric/components/DeviceCredentials/DELETE_PWD';
export const SORT_ROWS_PWD =
  'ipfabric/components/DeviceCredentials/SORT_ROWS_PWD';
export const SORT_ROWS_ENABLE_PWD =
  'ipfabric/components/DeviceCredentials/SORT_ROWS_ENABLE_PWD';
export const OPEN_EDIT_USER_DIALOGUE =
  'ipfabric/components/DeviceCredentials/OPEN_EDIT_USER_DIALOGUE';
export const CLOSE_EDIT_USER_DIALOGUE =
  'ipfabric/components/DeviceCredentials/CLOSE_EDIT_USER_DIALOGUE';
export const CLOSE_ENABLE_PWD_DIALOGUE =
  'ipfabric/components/DeviceCredentials/CLOSE_ENABLE_PWD_DIALOGUE';
export const OPEN_ENABLE_PWD_DIALOGUE =
  'ipfabric/components/DeviceCredentials/OPEN_ENABLE_PWD_DIALOGUE';
export const ADD_ENABLE_PWD =
  'ipfabric/components/DeviceCredentials/ADD_ENABLE_PWD';
export const DELETE_ENABLE_PWD =
  'ipfabric/components/DeviceCredentials/DELETE_ENABLE_PWD';
export const UPDATE_ENABLE_PWD =
  'ipfabric/components/DeviceCredentials/UPDATE_ENABLE_PWD';
export const FETCH_PWDLIST =
  'ipfabric/components/DeviceCredentials/FETCH_PWDLIST';
export const FETCH_ENABLE_PWDLIST =
  'ipfabric/components/DeviceCredentials/FETCH_ENABLE_PWDLIST';
export const FETCH_GLOBAL_PWDLIST =
  'ipfabric/components/DeviceCredentials/FETCH_GLOBAL_PWDLIST';
export const FETCH_GLOBAL_ENABLE_PWDLIST =
  'ipfabric/components/DeviceCredentials/FETCH_GLOBAL_ENABLE_PWDLIST';
export const SAVE_AUTHENTICATION =
  'ipfabric/components/DeviceCredentials/SAVE_AUTHENTICATION';

export const PWDLIST_CONFIRM_DIALOG =
  'ipfabric/components/DeviceCredentials/PWDLIST_CONFIRM_DIALOG';
export const ENABLE_PWDLIST_CONFIRM_DIALOG =
  'ipfabric/components/DeviceCredentials/ENABLE_PWDLIST_CONFIRM_DIALOG';
